import { useState, useRef } from "react"
import { NewConfirmModal } from "ui/NewConfirmModal"

export const useNewConfirmModal = () => {
  const [modalProps, setModalProps] = useState({})
  const [visible, setVisible] = useState(false)
  const confirmCallback = useRef(null)

  const showConfirm = (props, cb) => {
    setModalProps(props)
    confirmCallback.current = cb
    setVisible(true)
  }

  const handleConfirm = () => {
    setVisible(false)
    if (typeof confirmCallback.current === "function") {
      confirmCallback.current()
    }
    confirmCallback.current = null // Clear callback after use
  }

  const handleClose = () => {
    setVisible(false)
    confirmCallback.current = null // Clear on close too
  }

  return {
    showConfirm,
    modal: (
      <NewConfirmModal
        {...modalProps}
        visible={visible}
        onClose={handleClose}
        onConfirm={handleConfirm}
        onlyPublish={modalProps.onlyPublish}
      />
    )
  }
}
